import {AppLoader, Header} from '../../../components/index.js';
import {AxiosHelperPortal} from '../../../utility/index.js';
import {useEffect, useState} from 'react';
import OrderDetails from './OrderDetails.js';
import PaymentDetails from './PaymentDetails.js';
import AttachedAppointments from './AttachedAppointments.js';
import InstallmentPayments from './InstallmentPayments.js';
import { useLocation } from 'react-router-dom';
import { BASE_URL_WEB } from '../../../utility/constants';

export default function OrderDetailsPage() {
 
  const location = useLocation();
  const [orderData, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cancelAndRefundView, setCancelAndRefundView] = useState(false);
  const orderId = location?.state?.orderId || null;
  const companyId = location?.state?.companyId || null;
  useEffect(() => {
    if (orderId) {
      getOrderDetails();
    }
  }, [orderId]);
  const getOrderDetails = async () => {
    setLoading(true);
    console.log('orderId', orderId);
    const url = `${BASE_URL_WEB}order-details-show/` + orderId + `/` + companyId + `?`;
    const response = await AxiosHelperPortal(url, 'get');
    if (response?.status === 200) {
      console.log('response111', response);
      setOrder(response.data);
    }
    setLoading(false);
  };
  console.log('order1111111', orderData);
  if (loading || !orderData) {
    return <AppLoader />;
  }
  const installmentData = orderData?.installmentData || [];
  const isInst = orderData.isInst;
  installmentData?.sort((a, b) => new Date(a.dt) - new Date(b.dt));

  // Summation for total price (OrderDetails)
  const installmentTotal =
    installmentData?.reduce((acc, inst) => acc + (parseFloat(inst.amt) || 0), 0) || 0;
  const totalPriceIncludingInstallments = installmentTotal.toFixed(2);
  const hasInstallments = installmentData?.length > 0 ? 'Yes' : 'No';

  let totalInstallmentAmount = 0;
  let totalSquareAmount = 0;
  let totalPlatformFess = 0;
  let totalAmountTransferedToCoach = 0;

  if (isInst) {
    const processedSqPaymentIds = new Set();
    installmentData?.forEach(inst => {
      if (inst.square) {
        const totalMoney = inst.square?.total_money / 100;
        const processingFee = (inst.square?.processing_fee ?? 0) / 100;
        const appFee = (inst.square?.app_fee_money ?? 0) / 100;
        const amountToCoach = totalMoney - appFee - processingFee;

        // Only add if not yet accounted for & status is 'p' or 'pc'
        if (
          !processedSqPaymentIds.has(inst.sqPaymentId) &&
          (inst.status === 'p' || inst.status === 'pc')
        ) {
          totalSquareAmount += processingFee;
          totalPlatformFess += appFee;
          totalAmountTransferedToCoach += amountToCoach;
          processedSqPaymentIds.add(inst.sqPaymentId);
        }
      }
      // Only add if status 'p' or 'pc'
      if (inst.status === 'p' || inst.status === 'pc') {
        totalInstallmentAmount += parseFloat(inst.amt);
      }
    });
  }
  console.log('installmentData', installmentData);

  const handleBackButton = () => {
    setCancelAndRefundView(true);
  };
  return (
    <>
      <Header />
      <div className="row mt-5" style={{padding: '25px 100px'}}>
        <OrderDetails
          order={orderData.order}
          installmentData={installmentData}
          totalPriceIncludingInstallments={totalPriceIncludingInstallments}
          hasInstallments={hasInstallments}
        />
        <PaymentDetails
          orderData={orderData}
          isInst={isInst}
          totalInstallmentAmount={totalInstallmentAmount}
          totalSquareAmount={totalSquareAmount}
          totalPlatformFess={totalPlatformFess}
          totalAmountTransferedToCoach={totalAmountTransferedToCoach}
        />
        <AttachedAppointments appointments={orderData.appointments} order={orderData.order} />
      </div>
      {installmentData?.length > 0 && (
        <InstallmentPayments
          installmentData={installmentData}
          order={orderData.order}
          isInst={isInst}
          cancelAndRefundView={cancelAndRefundView}
        />
      )}
      {/* {cancelAndRefundView && (
        <CancelAndRefundInstallment
          props={orderData} // Replace with an empty object or the correct state variable if applicable
          installmentData={installmentData}
          handleBackButton={handleBackButton}
          appointments={orderData.appointments}
        />
      )} */}
    </>
  );
}
// Removed duplicate export default statement
